import { MdClose } from "react-icons/md";
import { FaDollarSign } from "react-icons/fa";
import { useEffect, useState } from "react";
import { CrearMultiplesPagos } from "../../utils/automateFuncions/CrearMultiplesPagos";
import { Button, CircularProgress } from "@mui/material";
import { getToday } from "../../utils/GetDates";
import GenerarCotizacionHyD from "../../utils/automateFuncions/GenerarCotizacionHyD";
import { BACKEND } from "../../config/configEnvs";
import axios from "axios";
import CheckBox from "../ui/components/CheckBox";


const AutogenerarCotizacionHyD = ({ open, onClose, idCotizacion, setPagos, setServicios, onSubmit }) => {

  const { start } = getToday()

  const [loading, setLoading] = useState(false)
  const [fechaInicio, setFechaInicio] = useState(start)
  const [selectedOption, setSelectedOption] = useState("Hosting y dominios")

  const [services, setServices] = useState([])
  const [selectedServices, setSelectedServices] = useState([])

  const getServices = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/servicios?limit=0&where[categoria][equals]=Hosting y dominio`)
      setServices(response.data.docs)
    } catch (error) {
      return false
    }
  }

  useEffect(() => {
    getServices()
  }, [])

  return (
    <div>
    {open && (
      <div
        className="max-w-2xl mx-auto bg-gray-100 p-4 shadow-lg rounded-md my-6"
      >
        <div className="flex justify-end">
          <div
            onClick={() => onClose()}
            className="cursor-pointer border border-gray-300 bg-gray-300 hover:bg-gray-400 transiton-all duration-100 p-2 rounded-md"
          >
            <MdClose className="text-black" />
          </div>
        </div>
        
        <div className=" ">
          <h3 className="text-center text-sm font-bold">Generar cotización hosting y dominios </h3>
        </div>

        <div className="mt-3">
          <div>
            <label
              htmlFor={"fechaInicio"}
              class="block mb-1 text-xs font-medium text-gray-900 flex flex-col gap-1"
            >
              <span className="font-semibold">Servicios a incluir</span>
              <span className="text-xs text-gray-400">Selecciona los servicios que deseas incluir en la cotización. Los planes los podrás colocar una vez creados los servicios.</span>
            </label>
            <div className="grid grid-cols-2 gap-4">
              {services.map((service) => (
                <div key={service.id} className="flex items-center gap-2">
                  <CheckBox 
                    checked={selectedServices.some(s => s.id === service.id)}
                    action={() => {
                      if (selectedServices.some(s => s.id === service.id)) {
                        setSelectedServices(prev => prev.filter(s => s.id !== service.id));
                      } else {
                        setSelectedServices(prev => [...prev, service]);
                      }
                    }}
                  />
                  <div className="flex flex-col gap-1 w-full">
                    <span className="text-xs font-medium">{service.name}</span>
                    {/* <select className="text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-1 w-2/3">
                      {service.preciosUnitarios.map((p) => (
                        <option key={p.plan.id} value={p.plan.id}>{p.plan.name}</option>
                      ))}
                    </select> */}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-3">
          <div>
            <label
              htmlFor={"fechaInicio"}
              class="block mb-1 text-xs font-medium text-gray-900 flex flex-col gap-1"
            >
              <span className="font-semibold">Fecha inicio</span>
              <span className="text-xs text-gray-400">En funcion de esta fecha se calcularán los pagos y las fecha de inicio de los servicios.</span>
            </label>
            <input 
              type="date"
              value={fechaInicio || ''}
              min={new Date().toISOString().split('T')[0]}
              className="text-gray-700 hover:cursor-pointer text-xs bg-white border w-full border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
              onChange={(e) => setFechaInicio(e.target.value)}
            />
          </div>
        </div>

        <div className="my-6 flex justify-center gap-4">
          <Button
            variant="contained"
            endIcon={loading ? <CircularProgress size={14} /> : <FaDollarSign size={14} />}
            disabled={loading}
            sx={{
              fontSize: "12px",
              fontWeight: "bold",
              fontFamily: "poppins", 
              padding: "4px 24px",
              backgroundColor: "#2563eb",
              textTransform: "none",
              borderRadius: "8px",
              width: "180px",
              '&:hover': {
                backgroundColor: "#1d4ed8",
              }
            }}
            onClick={() => GenerarCotizacionHyD({
              idCotizacion: idCotizacion, 
              setPagos: setPagos, 
              setServicios: setServicios, 
              services: selectedServices, 
              setLoading: setLoading, 
              fechaInicio: fechaInicio,
              onSubmit: onSubmit
            })}
          >
            Generar
          </Button>
        </div>
      </div>
    )}

  </div>
  )
}

export default AutogenerarCotizacionHyD;